module.exports = __webpack_public_path__ + "static/media/helicopter.7f27a450.svg";